import { EventType } from "../event-type";

export class ChildbirthType extends EventType {
    public static readonly INDUCTION = new ChildbirthType('childBirthInduction', 'Indução');
    public static readonly CONVENTIONAL = new ChildbirthType('childBirthConventional', 'Natural');
    public static readonly ABORTION = new ChildbirthType('childBirthAbortion', 'Aborto');

    private constructor(
        public readonly name: string,
        public readonly label: string,
        public readonly iconPath: string = EventType.CHILDBIRTH.iconPath,
        public readonly backgroundColor: string = EventType.CHILDBIRTH.backgroundColor
    ) { 
        super(name, label, iconPath, backgroundColor);
    }

    public static get(name: string): ChildbirthType {
        const type = Object.values(ChildbirthType).find((it) => it.name === name);
        if (type == null) {
            throw new Error(`${name} is not a mapped ChildbirthType.`);
        };
        return type;
    }

    public static getSelectableTypes(): ChildbirthType[] {
        return [this.INDUCTION, this.CONVENTIONAL];
    }
}
